var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isInstructionsActive && _vm.isVrMode,
          expression: "isInstructionsActive && isVrMode",
        },
      ],
      staticClass: "instructions",
    },
    [
      _c(
        "a",
        {
          staticClass: "instructions-close",
          attrs: { href: "javascript:" },
          on: { click: _vm.exitVrMode },
        },
        [
          _c("svg-icon", {
            staticClass: "icon-close",
            attrs: { name: "close" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "instructions-inner" },
        [
          _c("icon", { staticClass: "icon-mobile" }),
          _vm._v(" "),
          _c("icon", { staticClass: "icon-cardboard" }),
          _vm._v(" "),
          _c("p", {
            staticClass: "instructions-text",
            domProps: { innerHTML: _vm._s(_vm.$t("vrInstructions")) },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }